import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of, EMPTY } from 'rxjs';

import { environment } from 'src/environments/environment';
import { concatMap, catchError, delay, map } from 'rxjs/operators';
import { DataStorageService } from 'assurcard-angular-library';
import { TranslationService } from '../../api/services';
import { Translations } from './translations';

export class HttpLoader implements TranslateLoader {
  private readonly _translationsStorageKey = 'translations_';
  constructor(private storageService: DataStorageService, private translationService: TranslationService) { }

  getTranslation(lang: string): Observable<any> {
    const storageKey = `${this._translationsStorageKey}_${lang}`;
    return this.translationService.translationGet({
      langCode: lang,
      translationTypeCode: environment.RefTranslationTypeCode
    }).pipe(
      concatMap((translations) => {
        const json = JSON.parse(translations) as Translations[];
        return this.storageService.save<Translations[]>(storageKey, json).pipe(
          map(() => json)
        );
      }),
      catchError((err) => {
        return this.storageService.get<Translations>(storageKey);
      })
    );
  }
}
